import { render, staticRenderFns } from "./image-preview.vue?vue&type=template&id=636c0f4e&scoped=true&"
import script from "./image-preview.vue?vue&type=script&lang=js&"
export * from "./image-preview.vue?vue&type=script&lang=js&"
import style0 from "./image-preview.vue?vue&type=style&index=0&id=636c0f4e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636c0f4e",
  null
  
)

export default component.exports